'use client';
import { useEffect, useState } from 'react';
import type { AssistantAttachment } from '@/utils/assistant/attachmentTypes';
import { Modal } from '@/components/ui/modal';

export function ScreenshotPreview({ attachment, loadAttachment }: {
  attachment: AssistantAttachment;
  loadAttachment?: (id: string) => Promise<Blob>;
}) {
  const [url, setUrl] = useState<string>();
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    let active = true;
    let objectUrl: string | undefined;
    setUrl(undefined); setError(false);
    if (loadAttachment) {
      loadAttachment(attachment.id).then(blob => {
        if (!active) return;
        objectUrl = URL.createObjectURL(blob); setUrl(objectUrl);
      }).catch(() => { if (active) setError(true); });
    }
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [attachment.id, loadAttachment, attempt]);
  return <div className="mt-2">
    {url ? <button type="button" onClick={() => setExpanded(true)} aria-label={`Open ${attachment.name}`}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={url} alt={attachment.name} className="max-h-48 max-w-full rounded-lg object-contain" />
    </button> : <span className="text-xs">{error ? 'Screenshot could not be loaded.' : attachment.name}</span>}
    {error && <button type="button" className="ml-2 underline text-xs" onClick={() => setAttempt(value => value + 1)}>Try again</button>}
    <Modal isOpen={expanded && !!url} onClose={() => setExpanded(false)} className="max-w-4xl">
      <Modal.Header>{attachment.name}</Modal.Header>
      <Modal.Content>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={url} alt={attachment.name} className="w-full object-contain" />
      </Modal.Content>
    </Modal>
  </div>;
}
